import React from "react";

export interface ScriptProps {
  isAsync: boolean;
  onLoaded?: () => void;
  src: string;
}

const Script = (props: ScriptProps) => {
  React.useEffect(() => {
    const id = props.src.replace(/[^A-Za-z\d]/g, "");
    const el = document.querySelector(`#${id}`);
    if (!el) {
      const script = document.createElement("script") as HTMLScriptElement;
      script.onload = props.onLoaded ?? null;
      script.id = id;
      script.src = props.src;
      script.async = props.isAsync;

      document.body.append(script);
    } else {
      props.onLoaded && props.onLoaded();
    }
  }, [props.onLoaded, props.src, props.isAsync]);

  return null;
};
export default Script;
